<div #modal class="modal-content" *ngIf="IsLoadData">
    <div>
        <div
            class="modal-header"
            style="
                background-color: #569c5b;
                color: #fff;
                align-items: center;
                cursor: all-scroll;
                padding: 0.2rem 1rem;
                display: flex;
                justify-content: space-between;
            "
        >
            <h4 class="modal-title pl-3" style="margin: 0">
                Détails
                <strong class="cursor-pointer">
                    [{{ listDemandes.numero_demande }}]
                </strong>
            </h4>
            <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="handleCloseModal()"
            >
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body" [formGroup]="formTraitementMasse">
            <div class="row">
                <div class="col-lg-2">
                    <!-- <div [style]="{ marginTop: '-1rem' }" class="mb-2">
                        <div class="row">
                            <div class="col-md-12">
                                <fieldset>
                                    <legend>
                                        <b>Identification</b>
                                    </legend>
                                    <div>
                                        <div class="d-flex gap-4">
                                            <div class="d-flex gap-4">
                                                <div class="trans-radio d-flex gap-3 align-items-center">
                                                    <input class="form-check-input" type="radio" name="identification"
                                                        value="cloturer" id="cloturer" formControlName="operation"
                                                        style="
                                                            width: 39px;
                                                            height: 29px;
                                                            border-radius: 50%;
                                                        " />
                                                    <label for="cloturer" style="
                                                            margin-top: 0.9rem;
                                                        ">Clôturer</label>
                                                </div>
                                            </div>
                                            <div class="d-flex gap-4">
                                                <div class="trans-radio d-flex gap-3 align-items-center">
                                                    <input class="form-check-input" type="radio" name="identification"
                                                        value="traiter" id="traiter" formControlName="operation" style="
                                                            width: 39px;
                                                            height: 29px;
                                                            border-radius: 50%;
                                                        " />
                                                    <label for="traiter" style="
                                                            margin-top: 0.9rem;
                                                        ">Traiter</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div> -->
                    <div class="d-flex gap-2 no-wrap">
                        <button
                            pButton
                            pRipple
                            [label]="params.action"
                            (click)="onLetDownDemands()"
                            class="p-button-warning w-100"
                            *ngIf="
                                params.vue === 'activation' &&
                                params.action === 'Abandonner'
                            "
                        ></button>
                        <!-- <button pButton pRipple label="Abandonner" (click)="onLetDownDemands()"
                            class="p-button-warning w-100" *ngIf="
                            listDemandes.status === stateSoumis &&
                            listDemandes.traitement === treatmenEntente
                            "></button> -->
                        <button
                            pButton
                            pRipple
                            [label]="params.action"
                            [disabled]="formTraitementMasse.invalid"
                            (click)="onSaveDemandes()"
                            class="p-button-success w-100"
                            *ngIf="
                                params.vue === 'activation' &&
                                params.action === 'Identifier' &&
                                canIdentify(listDemandes)
                            "
                        ></button>
                        <button
                            pButton
                            pRipple
                            label="Soumettre"
                            [disabled]="formTraitementMasse.invalid"
                            (click)="onSaveTraitements()"
                            class="p-button-success w-100"
                            *ngIf="
                                params.vue === 'traitement' &&
                                params.action === 'Clôturer'
                            "
                        ></button>
                    </div>

                    <div>
                        <fieldset>
                            <legend>
                                <strong>Emission</strong>
                            </legend>
                            <div class="d-flex flex-column gap-2">
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Matricule&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.demandeur_matricule ??
                                                'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong
                                            >Nom complet&nbsp;:&nbsp;</strong
                                        >
                                        {{
                                            listDemandes?.demandeur_nom ?? 'N/A'
                                        }}
                                        {{
                                            listDemandes?.demandeur_prenoms ??
                                                'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Contact&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.demandeur_contacts ??
                                                'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Email&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.demandeur_email ??
                                                'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Date&nbsp;:&nbsp;</strong>
                                        {{ listDemandes?.created_at }}
                                    </span>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div>
                        <fieldset *ngIf="listDemandes?.approbateur">
                            <legend>
                                <strong>Approbateur</strong>
                            </legend>
                            <div class="d-flex flex-column gap-2">
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Matricule&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.approbateur
                                                ?.matricule ?? 'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong
                                            >Nom complet&nbsp;:&nbsp;</strong
                                        >
                                        {{
                                            listDemandes?.approbateur?.nom ??
                                                'N/A'
                                        }}
                                        {{
                                            listDemandes?.approbateur
                                                ?.prenoms ?? 'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Contact&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.approbateur
                                                ?.contacts ?? 'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Email&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.approbateur?.email ??
                                                'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30">
                                        <strong>Date&nbsp;:&nbsp;</strong>
                                        {{ listDemandes?.acquitte_a ?? 'N/A' }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30">
                                        <strong>Lignes&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.nb_demande_traitees ||
                                                0
                                        }}
                                        /
                                        {{
                                            listDemandes?.nb_demande_soumises ||
                                                0
                                        }}
                                    </span>
                                </div>
                            </div>
                        </fieldset>
                    </div>

                    <div>
                        <fieldset *ngIf="listDemandes?.finalisateur">
                            <legend>
                                <strong>Finalisation</strong>
                            </legend>
                            <div class="d-flex flex-column gap-2">
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Matricule&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.finalisateur
                                                ?.matricule ?? 'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong
                                            >Nom complet&nbsp;:&nbsp;</strong
                                        >
                                        {{
                                            listDemandes?.finalisateur?.nom ??
                                                'N/A'
                                        }}
                                        {{
                                            listDemandes?.finalisateur
                                                ?.prenoms ?? 'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30">
                                        <sstrong>Contact&nbsp;:&nbsp;</sstrong>
                                        {{
                                            listDemandes?.finalisateur
                                                ?.contacts ?? 'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30"
                                        ><strong>Email&nbsp;:&nbsp;</strong>
                                        {{
                                            listDemandes?.finalisateur?.email ??
                                                'N/A'
                                        }}
                                    </span>
                                </div>
                                <div>
                                    <span class="mb-0 fs__30">
                                        <strong>Date&nbsp;:&nbsp;</strong>
                                        {{ listDemandes?.finalise_a ?? 'N/A' }}
                                    </span>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>

                <div class="col-lg-10">
                    <div class="col-lg-12">
                        <div
                            role="alert"
                            style="
                                display: flex;
                                justify-content: space-between;
                            "
                            [ngClass]="OnGetRapportCodeStyle(listDemandes)"
                        >
                            <div>
                                <strong class="wrapper-header">
                                    {{ BADGE_ETAPE.SOUMISSION | capitalize }} :
                                    {{ listDemandes?.etat_soumission }}
                                    <br />
                                    Date : [{{
                                        listDemandes?.etat_soumission ===
                                        'abandonné'
                                            ? listDemandes?.cloture_a
                                            : listDemandes?.created_at ??
                                              '-- : --'
                                    }}]
                                </strong>
                            </div>
                            <div>
                                <strong class="wrapper-header">
                                    {{ BADGE_ETAPE.TRAITEMENT | capitalize }} :
                                    {{ listDemandes?.etat_traitement }}
                                    <br />
                                    Date : [{{
                                        listDemandes?.traite_a ?? '-- : --'
                                    }}]
                                </strong>
                            </div>
                            <div>
                                <strong class="wrapper-header">
                                    {{ BADGE_ETAPE.FINALISATEUR | capitalize }}
                                    :
                                    {{ listDemandes?.etat_finalisation }}
                                    <br />
                                    Date : [{{
                                        listDemandes?.finalise_a ?? '-- : --'
                                    }}]
                                </strong>
                            </div>
                            <div>
                                <strong class="wrapper-header">
                                    <span class="text-capitalize">{{
                                        BADGE_ETAPE.CLOTURE
                                    }}</span>
                                    : {{ listDemandes?.etat_cloture }}
                                    <br />
                                    Date : [{{
                                        listDemandes?.cloture_a ?? '-- : --'
                                    }}]
                                </strong>
                            </div>
                        </div>
                        <div class="row">
                            <h4 class="col-md-7 wrapper-header">
                                <strong
                                    >{{
                                        getTitleForm(listDemandes?.operation)
                                    }}&nbsp;{{
                                        listDemandes?.numero_demande
                                    }}</strong
                                >
                            </h4>
                            <div
                                class="col-md-5 wrapper-header"
                                style="
                                    display: flex;
                                    justify-content: end;
                                    font-size: 20px;
                                "
                            >
                                Date mise à jour :&nbsp;<b
                                    ><span>{{
                                        listDemandes.updated_at ?? 'N/A'
                                    }}</span></b
                                >
                            </div>
                        </div>

                        <hr
                            style="
                                position: relative;
                                top: -0.2rem;
                                margin-top: -0.8rem;
                            "
                        />

                        <div>
                            <div>
                                <!-- <div [style]="{ marginTop: '-1rem' }">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <fieldset>
                                                <legend>
                                                    <b>Stock SIM/OCI</b>
                                                </legend>
                                                <div class="text-wrapper">
                                                    <input
                                                        type="text"
                                                        pInputText
                                                        [value]="
                                                            sourceStockOrangeSim
                                                        "
                                                        [disabled]="true"
                                                    />
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div> -->
                                <fieldset>
                                    <legend>
                                        <strong>Informations demande</strong>
                                    </legend>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label
                                                    ><b
                                                        >Désignation<span
                                                            class="text-danger"
                                                            >*</span
                                                        ></b
                                                    ></label
                                                >
                                                <input
                                                    formControlName="operation"
                                                    type="text"
                                                    pInputText
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <div class="form-group">
                                                <label><b>PU (Fcfa)</b></label>
                                                <input
                                                    formControlName="prix_unitaire"
                                                    type="text"
                                                    pInputText
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <div class="form-group">
                                                <label><b>Quantité</b></label>
                                                <input
                                                    formControlName="nb_demande_soumises"
                                                    type="number"
                                                    pInputText
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <div class="form-group">
                                                <label
                                                    ><b
                                                        >Montant HT (Fcfa)</b
                                                    ></label
                                                >
                                                <input
                                                    placeholder="nombre"
                                                    formControlName="prix_ht"
                                                    type="text"
                                                    pInputText
                                                />
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <div class="form-group">
                                                <label
                                                    ><b
                                                        >Montant TTC (Fcfa)</b
                                                    ></label
                                                >
                                                <input
                                                    placeholder="nombre"
                                                    formControlName="prix_ttc"
                                                    type="text"
                                                    pInputText
                                                />
                                            </div>
                                        </div>

                                        <div
                                            class="col-md"
                                            *ngIf="
                                                this.params.vue ===
                                                'SIM blanche'
                                            "
                                        >
                                            <label for="commentaire"
                                                ><strong
                                                    >Courrier ou
                                                    Document</strong
                                                ></label
                                            >
                                            <div
                                                class="d-flex justify-content-center align-items-center container-button-telecharger"
                                            >
                                                <div
                                                    *ngIf="
                                                        displayBoutonJustificatif()
                                                    "
                                                >
                                                    <button
                                                        pButton
                                                        pRipple
                                                        label="Télécharger"
                                                        icon="pi pi-download"
                                                        class="p-button-success"
                                                        (click)="
                                                            downloadFile(
                                                                'justificatif'
                                                            )
                                                        "
                                                    ></button>
                                                </div>
                                                <div class="justificatif-error">
                                                    <span
                                                        class=""
                                                        *ngIf="
                                                            !displayBoutonJustificatif()
                                                        "
                                                    >
                                                        <b
                                                            class="disabled-piece-jointe"
                                                            >Aucune pièce
                                                            jointe</b
                                                        >
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-3">
                                            <label for="commentaire"
                                                ><strong
                                                    >Courrier ou
                                                    Document</strong
                                                ></label
                                            >
                                            <div
                                                class="d-flex justify-content-center align-items-center container-button-telecharger"
                                            >
                                                <div
                                                    *ngIf="
                                                        displayBoutonJustificatif()
                                                    "
                                                >
                                                    <button
                                                        pButton
                                                        pRipple
                                                        label="Télécharger"
                                                        icon="pi pi-download"
                                                        class="p-button-success"
                                                        (click)="
                                                            downloadFile(
                                                                'justificatif'
                                                            )
                                                        "
                                                    ></button>
                                                </div>
                                                <div class="justificatif-error">
                                                    <span
                                                        class=""
                                                        *ngIf="
                                                            !displayBoutonJustificatif()
                                                        "
                                                    >
                                                        <b
                                                            class="disabled-piece-jointe"
                                                            >Aucune pièce
                                                            jointe</b
                                                        >
                                                    </span>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </fieldset>
                                <fieldset
                                    *ngIf="this.params.vue !== 'SIM blanche'"
                                >
                                    <legend>Demande</legend>
                                    <div class="row">
                                        <ng-container
                                            *ngIf="
                                                listDemandes.operation ===
                                                TYPE_FORM.ACTIVATION
                                            "
                                        >
                                            <div class="col-md-1">
                                                <label><b>Nombre</b></label>
                                                <input
                                                    type="text"
                                                    pInputText
                                                    formControlName="nb_demande_soumises"
                                                />
                                            </div>
                                        </ng-container>

                                        <ng-container
                                            *ngIf="
                                                typeOperation ===
                                                TYPE_FORM.INTEGRATION
                                            "
                                        >
                                            <div class="col-md-2">
                                                <label
                                                    ><b
                                                        >Montant de la
                                                        formule/SIM</b
                                                    ></label
                                                >
                                                <input
                                                    type="text"
                                                    pInputText
                                                    formControlName="montant_formule"
                                                />
                                            </div>
                                        </ng-container>
                                        <div class="col-md-2">
                                            <label><b>Usage</b></label>
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="usage_id"
                                            />
                                        </div>
                                        <div class="col-md">
                                            <label
                                                ><b
                                                    >Formule destination<span
                                                        class="text-danger"
                                                        >*</span
                                                    ></b
                                                ></label
                                            >
                                            <!-- <p-dropdown [options]="listFormules" formControlName="formule_uuid"
                                                optionLabel="nom" optionValue="uuid"
                                                placeholder="Sélectionner la formule de destination"
                                                [showClear]="true" name="formule_uuid">
                                            </p-dropdown> -->

                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="formule_uuid"
                                                pTooltip="{{
                                                    formTraitementMasse.get(
                                                        'formule_uuid'
                                                    )?.value
                                                }}"
                                            />
                                        </div>
                                        <div class="col-md-3">
                                            <label for="commentaire"
                                                ><strong
                                                    >Paiement</strong
                                                ></label
                                            >
                                            <div
                                                class="d-flex justify-content-center align-items-center container-button-telecharger"
                                            >
                                                <div
                                                    *ngIf="
                                                        listDemandes?.type_paiement ===
                                                        BADGE_STAUT_PAIEMENT.DIFFERE
                                                    "
                                                >
                                                    <b
                                                        class="disabled-piece-jointe"
                                                        >Differé sur la
                                                        facture</b
                                                    >
                                                </div>
                                                <div
                                                    *ngIf="
                                                        listDemandes?.type_paiement ===
                                                        BADGE_STAUT_PAIEMENT.MON_COMPTE
                                                    "
                                                >
                                                    <b
                                                        class="disabled-piece-jointe"
                                                        >Débité de votre
                                                        compte</b
                                                    >
                                                </div>
                                                <div class="justificatif-error">
                                                    <span
                                                        class=""
                                                        *ngIf="
                                                            listDemandes?.type_paiement ===
                                                            BADGE_STAUT_PAIEMENT.IMMEDIAT
                                                        "
                                                    >
                                                        <button
                                                            pButton
                                                            pRipple
                                                            label="Réçu"
                                                            icon="pi pi-download"
                                                            class="p-button-success"
                                                            (click)="
                                                                downloadFile(
                                                                    'recu_paiement'
                                                                )
                                                            "
                                                        ></button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md">
                                            <label for="commentaire"
                                                ><strong
                                                    >Courrier ou
                                                    Document</strong
                                                ></label
                                            >
                                            <div
                                                class="d-flex justify-content-center align-items-center container-button-telecharger"
                                            >
                                                <div
                                                    *ngIf="
                                                        displayBoutonJustificatif()
                                                    "
                                                >
                                                    <button
                                                        pButton
                                                        pRipple
                                                        label="Télécharger"
                                                        icon="pi pi-download"
                                                        class="p-button-success"
                                                        (click)="
                                                            downloadFile(
                                                                'justificatif'
                                                            )
                                                        "
                                                    ></button>
                                                </div>
                                                <div class="justificatif-error">
                                                    <span
                                                        class=""
                                                        *ngIf="
                                                            !displayBoutonJustificatif()
                                                        "
                                                    >
                                                        <b
                                                            class="disabled-piece-jointe"
                                                            >Aucune pièce
                                                            jointe</b
                                                        >
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>

                                <!-- <fieldset>
                                    <legend>
                                        <b>Informations d'affectation</b>
                                    </legend>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <label>
                                                <b>{{
                                                    firstLevelLibelle
                                                }}</b></label
                                            >
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="niveau_uns_uuid"
                                            />
                                        </div>
                                        <div class="col-md-4">
                                            <label>
                                                <b>{{ secondLevelLibelle }}</b>
                                            </label>
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="niveau_deux_uuid"
                                            />
                                        </div>
                                        <div class="col-md-4">
                                            <label>
                                                <b>{{ thirdLevelLibelle }}</b>
                                            </label>
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="niveau_trois_uuid"
                                            />
                                        </div>
                                    </div>
                                </fieldset> -->

                                <fieldset>
                                    <legend>
                                        <b>Commentaire de la Demande</b>
                                    </legend>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!-- <label for="commentaire"
                                                ><strong
                                                    >Description</strong
                                                ></label
                                            > -->
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="description"
                                            />
                                        </div>
                                    </div>
                                </fieldset>

                                <!-- <fieldset>
                                    <legend>
                                        <strong>Commentaire</strong>
                                    </legend>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="commentaire"><strong>Commentaire clôture</strong></label>
                                            <textarea name="commentaire" formControlName="commentaire_cloture"
                                            class="form-control" rows="1" style="width: 100%; margin-top: 0%">
                                            </textarea>
                                        </div>
                                        
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label for="commentaire"><strong>Commentaire traitement</strong></label>
                                        <textarea name="commentaire" formControlName="commentaire_traitement"
                                            class="form-control" rows="1" style="width: 100%; margin-top: 0%">
                                            </textarea>
                                        </div>
                                    </div>
                                </fieldset> -->

                                <fieldset
                                    *ngIf="
                                        !(
                                            params.vue === 'activation' &&
                                            params.action === 'Identifier' &&
                                            canIdentify(listDemandes)
                                        ) &&
                                        !(
                                            params.vue === 'activation' &&
                                            params.action === 'Abandonner'
                                        )
                                    "
                                >
                                    <legend><strong>Traitement</strong></legend>
                                    <div class="d-flex gap-2 no-wrap">
                                        <div
                                            style="width: 100%"
                                            *ngIf="
                                                (params.vue === 'traitement' &&
                                                    params.action ===
                                                        'Clôturer') ||
                                                (!(
                                                    params.vue ===
                                                        'traitement' &&
                                                    params.action === 'Clôturer'
                                                ) &&
                                                    !(
                                                        params.vue ===
                                                            'activation' &&
                                                        params.action ===
                                                            'Identifier' &&
                                                        canIdentify(
                                                            listDemandes
                                                        )
                                                    ) &&
                                                    !(
                                                        params.vue ===
                                                            'activation' &&
                                                        params.action ===
                                                            'Abandonner'
                                                    ))
                                            "
                                        >
                                            <label for="commentaire"
                                                ><strong
                                                    >Commentaire
                                                    traitement</strong
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="commentaire_traitement"
                                            />
                                        </div>
                                        <div
                                            style="width: 100%"
                                            *ngIf="
                                                (params.vue === 'traitement' &&
                                                    params.action ===
                                                        'Clôturer') ||
                                                (!(
                                                    params.vue ===
                                                        'traitement' &&
                                                    params.action === 'Clôturer'
                                                ) &&
                                                    !(
                                                        params.vue ===
                                                            'activation' &&
                                                        params.action ===
                                                            'Identifier' &&
                                                        canIdentify(
                                                            listDemandes
                                                        )
                                                    ) &&
                                                    !(
                                                        params.vue ===
                                                            'activation' &&
                                                        params.action ===
                                                            'Abandonner'
                                                    ))
                                            "
                                        >
                                            <label for="commentaire"
                                                ><strong
                                                    >Commentaire
                                                    finalisation</strong
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="commentaire_finalisation"
                                            />
                                        </div>
                                        <div
                                            style="width: 100%"
                                            *ngIf="
                                                !(
                                                    params.vue ===
                                                        'traitement' &&
                                                    params.action === 'Clôturer'
                                                ) &&
                                                !(
                                                    params.vue ===
                                                        'activation' &&
                                                    params.action ===
                                                        'Identifier' &&
                                                    canIdentify(listDemandes)
                                                ) &&
                                                !(
                                                    params.vue ===
                                                        'activation' &&
                                                    params.action ===
                                                        'Abandonner'
                                                )
                                            "
                                        >
                                            <label for="commentaire"
                                                ><strong
                                                    >Commentaire clôture</strong
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                pInputText
                                                formControlName="commentaire_cloture"
                                            />
                                        </div>
                                    </div>
                                </fieldset>

                                <fieldset
                                    *ngIf="
                                        (params.vue === 'traitement' &&
                                            params.action === 'Clôturer') ||
                                        (listDemandes?.statut ===
                                            BADGE_ETAPE.CLOTURE &&
                                            listDemandes?.traitement ===
                                                BADGE_ETAT.TERMINE)
                                    "
                                >
                                    <legend><strong>Clôture</strong></legend>
                                    <div
                                        class="wrapper-evaluation"
                                        style="display: flex; gap: 1rem"
                                    >
                                        <div class="block-checked">
                                            <div
                                                style="margin-left: 8%"
                                                class="ml-3"
                                            >
                                                <span
                                                    for="accepte"
                                                    style="
                                                        font-size: 23px;
                                                        margin-left: 5%;
                                                        font-weight: 800;
                                                    "
                                                >
                                                    Accepté<span
                                                        class="text-danger"
                                                        >*</span
                                                    >?
                                                </span>
                                                <div class="wrapper-check">
                                                    <div
                                                        class="form-check form-check-inline"
                                                    >
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="demande"
                                                            value="oui"
                                                            id="infosLigne"
                                                            formControlName="accepte"
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="oui"
                                                            style="
                                                                width: auto !important;
                                                            "
                                                        >
                                                            Oui
                                                        </label>
                                                    </div>
                                                    <div
                                                        class="form-check form-check-inline"
                                                    >
                                                        <input
                                                            class="form-check-input"
                                                            type="radio"
                                                            name="demande"
                                                            value="non"
                                                            id="infosLigne"
                                                            formControlName="accepte"
                                                        />
                                                        <label
                                                            class="form-check-label"
                                                            for="non"
                                                            style="
                                                                width: auto !important;
                                                            "
                                                            >Non
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="block-checked"
                                            style="
                                                width: 15rem;
                                                padding: 0 0.5rem 0.5rem 0.5rem;
                                            "
                                        >
                                            <div class="ml-3">
                                                <div class="wrapper-check">
                                                    <div
                                                        style="
                                                            display: flex;
                                                            flex-direction: column;
                                                        "
                                                    >
                                                        <div>
                                                            <label
                                                                for="infosLigne"
                                                                style="
                                                                    margin-left: 0 !important;
                                                                "
                                                            >
                                                                <img
                                                                    src="assets/images/icones/smile.png"
                                                                    width="22"
                                                                    alt=""
                                                                />
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="infosLigne"
                                                                formControlName="notation_cloture"
                                                                value="content"
                                                                id="infosLigne"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        style="
                                                            display: flex;
                                                            flex-direction: column;
                                                        "
                                                    >
                                                        <div>
                                                            <label
                                                                for="infosLigne"
                                                                style="
                                                                    margin-left: 0 !important;
                                                                "
                                                            >
                                                                <img
                                                                    src="assets/images/icones/confused.png"
                                                                    width="22"
                                                                    alt=""
                                                                />
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="infosLigne"
                                                                formControlName="notation_cloture"
                                                                value="neutre"
                                                                id="infosLigne"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div
                                                        style="
                                                            display: flex;
                                                            flex-direction: column;
                                                        "
                                                    >
                                                        <div>
                                                            <label
                                                                for="infosLigne"
                                                                style="
                                                                    margin-left: 0 !important;
                                                                "
                                                            >
                                                                <img
                                                                    src="assets/images/icones/sad.png"
                                                                    width="22"
                                                                    alt=""
                                                                />
                                                            </label>
                                                        </div>
                                                        <div>
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                name="infosLigne"
                                                                formControlName="notation_cloture"
                                                                value="mécontent"
                                                                id="infosLigne"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="width: 100%">
                                            <label for="commentaire"
                                                ><strong
                                                    >Commentaire<span
                                                        class="text-danger"
                                                        [hidden]="
                                                            !croixRougeCommentaire
                                                        "
                                                        >*</span
                                                    ></strong
                                                ></label
                                            >
                                            <textarea
                                                name="commentaire"
                                                formControlName="commentaire"
                                                class="form-control"
                                                rows="2"
                                                style="
                                                    width: 100%;
                                                    margin-top: 0%;
                                                "
                                                placeholder="Entrer un commentaire"
                                            >
                                            </textarea>
                                        </div>
                                    </div>
                                </fieldset>

                                <br />

                                <fieldset
                                    *ngIf="
                                        params.vue === 'activation' &&
                                        params.action === 'Identifier' &&
                                        canIdentify(listDemandes)
                                    "
                                    class="padding-bottom-lignes"
                                >
                                    <legend>
                                        <b>Identification des lignes</b>
                                    </legend>
                                    <div class="row">
                                        <app-form-masse
                                            class="col-md-9 d-flex align-items-end"
                                            [fileModel]="fileModel"
                                            (dataToSend)="
                                                pushCurrentArrayForm($event)
                                            "
                                            [currentArrayHeaders]="
                                                currentArrayHeaders
                                            "
                                            (downloadModel)="
                                                onDownloadModel($event)
                                            "
                                            [formMasseLibelle]="
                                                formMasseLibelle
                                            "
                                            [libelleFile]="libelleFile"
                                        >
                                        </app-form-masse>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
